import React, { Component } from 'react'
import iconsSvg from '../../config/iconsSvg.json';

class IconRender extends Component {

    renderSingleStandardIcon(name, size, verticalAlign) {
        return (
            <React.Fragment>
                {this.props.name === name
                    && <svg xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: verticalAlign }}
                        width={size} height={size} fill="currentColor" className={`bi bi-${name}`} viewBox="0 0 16 16">
                        <path fillRule="evenodd" d={iconsSvg[name]} />
                    </svg>
                }
            </React.Fragment>
        );
    }
    renderSingleStandardIconDouble(name, size, verticalAlign) {
        return (
            <React.Fragment>
                {this.props.name === name
                    && <svg xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: verticalAlign }}
                    width={size} height={size} fill="currentColor" className={`bi bi-${name}`} viewBox="0 0 16 16">
                        <path d={iconsSvg[name][0]} />
                        <path d={iconsSvg[name][1]} />
                    </svg>
                }
            </React.Fragment>
        );
    }

    render() {
        const arrowRepeat = 'arrow-repeat';
        return (
            <React.Fragment>
                {this.renderSingleStandardIcon('arrows-expand','19','-3px')}
                {this.renderSingleStandardIcon('arrows-collapse','19','-3px')}
                {this.props.name === 'check'
                    &&
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: '-3px' }}
                        width="17" height="17" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
                        <path d={iconsSvg['check']} />
                    </svg>
                }
                {this.props.name === 'info-circle-fill'
                    &&
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: '-2px' }}
                        width="16" height="16" fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16">
                        <path d={iconsSvg['info-circle-fill']} />
                    </svg>
                }
                {this.renderSingleStandardIcon('chevron-up','16','-2px')}
                {this.renderSingleStandardIcon('chevron-down','16','-2px')}
                {this.props.name === 'x'
                    && <svg xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: '-2px' }}
                        width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d={iconsSvg['x']} />
                    </svg>
                }
                {this.renderSingleStandardIconDouble('question-circle','16','-2px')}
                {this.renderSingleStandardIconDouble('x-circle','16','-2px')}
                {this.renderSingleStandardIconDouble('trash','16','-2px')}
                {this.renderSingleStandardIconDouble('stickies','16','-2px')}
                {this.renderSingleStandardIconDouble('file-earmark-text','16','-2px')}
                {this.props.name === 'plus'
                    && <svg xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: '-2px' }}
                        width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                        <path d={iconsSvg['plus']} />
                    </svg>
                }
                {this.props.name === arrowRepeat
                    && <svg xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: '-2px' }}
                        width="16" height="16" fill="currentColor" className={`bi bi-${arrowRepeat}`} viewBox="0 0 16 16">
                        <path d={iconsSvg[arrowRepeat][0]} />
                        <path fillRule="evenodd" d={iconsSvg[arrowRepeat][1]} />
                    </svg>
                }
            </React.Fragment>
        )
    }
}

export default (IconRender)

